import React, { useState, useEffect } from "react";

// Herbruikbare, centraal geplaatste paging-balk: rijen-per-pagina-selector +
// vorige/volgende-navigatie + rechtstreeks naar een pagina springen, als één
// visueel geheel. Generiek genoeg om later voor andere tabellen in de app
// hergebruikt te worden (page/totalPages/pageSize zijn 0-indexed resp. 1-indexed
// waar van toepassing - page is 0-indexed, net als in ResultsConsultations).
export default function PaginationBar({
  page,
  totalPages,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) {
  const [jumpValue, setJumpValue] = useState(String(page + 1));

  useEffect(() => {
    setJumpValue(String(page + 1));
  }, [page]);

  const safeTotalPages = Math.max(totalPages, 1);

  const jumpToPage = () => {
    const target = parseInt(jumpValue, 10);
    if (!isNaN(target) && target >= 1 && target <= safeTotalPages) {
      onPageChange(target - 1);
    } else {
      setJumpValue(String(page + 1));
    }
  };

  return (
    <div className="flex justify-center mt-4">
      <div className="inline-flex flex-wrap items-center gap-4 bg-white border border-gray-200 rounded-lg shadow-sm px-4 py-2">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <label htmlFor="pagination-page-size">Rijen per pagina</label>
          <select
            id="pagination-page-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>

        <div className="h-5 border-l border-gray-200" />

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onPageChange(Math.max(0, page - 1))}
            disabled={page === 0}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
          >
            Vorige
          </button>

          <div className="flex items-center gap-1 text-sm text-gray-600">
            <span>Pagina</span>
            <input
              type="number"
              min={1}
              max={safeTotalPages}
              value={jumpValue}
              onChange={(e) => setJumpValue(e.target.value)}
              onBlur={jumpToPage}
              onKeyDown={(e) => {
                if (e.key === "Enter") jumpToPage();
              }}
              className="w-14 border border-gray-300 rounded px-1.5 py-1 text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <span>van {safeTotalPages}</span>
          </div>

          <button
            type="button"
            onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))}
            disabled={page >= totalPages - 1}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
          >
            Volgende
          </button>
        </div>
      </div>
    </div>
  );
}
